module.exports = __webpack_public_path__ + "static/media/ShaaileshAdmane.c5fa2dd5.png";